// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  revealId: __t.u64().primaryKey().name("reveal_id"),
  identity: __t.identity(),
  sigKey: __t.string().name("sig_key"),
  systemId: __t.string().name("system_id"),
  epoch: __t.u32(),
  kind: __t.string(),
  round: __t.u8(),
  bearingDeg: __t.f64().name("bearing_deg"),
  rangeM: __t.f64().name("range_m"),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  at: __t.timestamp(),
});
